import { Routes, Route, Navigate } from "react-router-dom";
import Sample from "../pages/Sample";
import AllPage from "../pages/AllPage";
import SingleProduct from "../pages/SingleProducts";
import Layout from "../components/kits/layout/Layout.jsx";
import FlowChart from "../components/flowchart/FlowChart.jsx";
import List from "../pages/product&services";
import TestTabs from "../components/tab/testTabs";
import Test from "../components/tableCard/test";
import UserManagement from "../components/user_management/UserManagement";

import CustomButton from "../components/kits/button/CustomButton.jsx";
import CustomersList from "../pages/CustomerList";
import ClewList from "../pages/ClewList";
import Icons from "../pages/Icons.jsx";
import TimeLine from "../components/kits/timeline/TimeLine.jsx";
import TimeLinePage from "../pages/TimeLinePage.jsx";
import Campaign from "../components/campaign/Campaign.jsx";
import OrderPage from "../pages/OrderPage";
import Factor from "../pages/Factor";
// import Test from "../components/tableCard/test.jsx";
// import Login from "../components/login/Login";
import Message from "../pages/Message";
import TransactionPage from "../pages/TransactionPage.jsx";

import Login from "../pages/Login";
import SingleCampaign from "../pages/SingleCampaign";
import AddAndEditOrders from "../pages/AddAndEditOrders";
import StoragePage from "../pages/StoragePage.jsx";
import FinancialManagement from "../pages/FinancialManagement";

import IconsPage from "../pages/IconsPage";
import ProtectedRoute from "./ProtectedRoute";
import ClewStepPage from "../pages/ClewStepPage";
import RegPerformance from "../pages/RegPerformance";
import PersonalPerformance from "../pages/PersonalPerformance";
import Chat from "../pages/ChatPage";
import ChatWidgetPage from "../pages/ChatWidgetPage";
import TestSamplePage from "../pages/TestSamplePage";
import ProductListPage from "../pages/ProductListPage";
import SingleProductNew from "../pages/SingleProductPage";
import CreateOrderPage from "../pages/CreateOrderPage";
import InventoryListPage from "../pages/InventoryListPage";
import OrderListPage from "../pages/OrderListPage";
import PrintFactorPage from "../pages/PrintFactorPage";
import CallForPrice from "../pages/CallForPrice";
export default function Router() {
  return (
    <Routes>
      <Route
        path="sample"
        element={
          <ProtectedRoute>
            <Layout>
              <Sample />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* development pages */}
      <Route
        path="all-page"
        element={
          <ProtectedRoute>
            <AllPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="icons"
        element={
          // <ProtectedRoute>
          <IconsPage />
          // </ProtectedRoute>
        }
      />
      {/* end of development pages */}
      <Route
        path="product/:productId"
        element={
          <ProtectedRoute>
            <Layout>
              <SingleProduct />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-panel/user-management"
        element={
          <ProtectedRoute>
            <Layout>
              <UserManagement />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* <Route path="product/:productId" element={<SingleProduct />} /> */}
      <Route
        path="layout"
        element={
          <ProtectedRoute>
            <Layout>
              <CustomButton
                color="primary"
                type="outline"
                size="large"
                className="mx-3"
                onClick={() => {
                  alert("hello");
                }}
              >
                دکمه دوست داشتنی
              </CustomButton>
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="flowchart"
        element={
          <ProtectedRoute>
            <Layout>
              <FlowChart />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="product-list"
        element={
          <ProtectedRoute>
            <Layout>
              <List />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="icons"
        element={
          <ProtectedRoute>
            <Icons />
          </ProtectedRoute>
        }
      />

      <Route
        path="timeline"
        element={
          <ProtectedRoute>
            <TimeLinePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="card"
        element={
          <ProtectedRoute>
            <Test />
          </ProtectedRoute>
        }
      />
      <Route
        path="campaign"
        element={
          <ProtectedRoute>
            <Layout>
              <Campaign />
            </Layout>
          </ProtectedRoute>
        }
      />
      {/* Optional CampaignId param for page */}
      <Route
        path="single-campaign/:campaignId?"
        element={
          <ProtectedRoute>
            <SingleCampaign />
          </ProtectedRoute>
        }
      />
      <Route
        path="login"
        element={
          <ProtectedRoute>
            <Login />
          </ProtectedRoute>
        }
      />
      <Route
        path="customer-list"
        element={
          <ProtectedRoute>
            <Layout>
              <CustomersList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="clew-list"
        element={
          <ProtectedRoute>
            <Layout>
              <ClewList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="order/:orderId"
        element={
          <ProtectedRoute>
            <Layout>
              <AddAndEditOrders />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="financial-management"
        element={
          <ProtectedRoute>
            <Layout>
              <FinancialManagement />
            </Layout>
          </ProtectedRoute>
        }
      />

      <Route
        path="orders"
        element={
          <ProtectedRoute>
            <Layout>
              <OrderPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="factor/:orderId"
        element={
          <ProtectedRoute>
            <Factor />
          </ProtectedRoute>
        }
      />
      <Route
        path="messages"
        element={
          <ProtectedRoute>
            <Layout>
              <Message />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="chat"
        element={
          <ProtectedRoute>
            <Layout>
              <Chat />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="chat-widget" element={<ChatWidgetPage />} />
      <Route
        path=""
        element={
          <ProtectedRoute>
            <Layout>
              <TransactionPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="storage"
        element={
          <ProtectedRoute>
            <Layout>
              <StoragePage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="clew-step"
        element={
          <ProtectedRoute>
            <Layout>
              <ClewStepPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <Navigate to={"/"} />
          </ProtectedRoute>
        }
      />
      <Route
        path="reg-performance"
        element={
          <ProtectedRoute>
            <Layout>
              <RegPerformance />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="personal-performance-report"
        element={
          <ProtectedRoute>
            <Layout>
              <PersonalPerformance />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="test-sample"
        element={
          // <ProtectedRoute>
          // <Layout>
          <TestSamplePage />
          // </Layout>
          // </ProtectedRoute>
        }
      />
      <Route
        path="new-product-list"
        element={
          <Layout>
            <ProductListPage />
          </Layout>
        }
      />
      <Route
        path="new-single-product/:productId"
        element={
          <Layout>
            <SingleProductNew />
          </Layout>
        }
      />
      <Route
        path="new-single-product/create"
        element={
          <Layout>
            <SingleProductNew />
          </Layout>
        }
      />
      <Route
        path="new-order/create/:typeId" //2 sell, 1 buy
        element={
          <Layout>
            <CreateOrderPage />
          </Layout>
        }
      />
      <Route
        path="new-order/edit/:typeId/:orderId" //2 sell, 1 buy
        element={
          <Layout>
            <CreateOrderPage />
          </Layout>
        }
      />
      <Route path="order-factor/:orderId" element={<PrintFactorPage />} />

      <Route
        path="new-inventory-list"
        element={
          <Layout>
            <InventoryListPage />
          </Layout>
        }
      />
      <Route
        path="new-order-list"
        element={
          <Layout>
            <OrderListPage />
          </Layout>
        }
      />
      <Route
        path="call-for-price/from-customer/flat-box/sadra"
        element={<CallForPrice />}
      />
    </Routes>
  );
}
